import { useViewsQuery } from '@platform/state/api';
import type { ISavedView } from '@platform/core/types';

/**
 * Вибране збережене подання списку (стан `savedViewId`) серед подань типу запису у воркспейсі; без вибору список подань не запитується.
 * API не застосовує подання саме (параметр `view` лише передається), тож його фільтр, сортування й стовпці бере модель списку.
 */
export function useSavedView(ws: string, recordType: string, savedViewId: string | null): ISavedView | undefined {
  const { data } = useViewsQuery({ ws, recordType }, { skip: !savedViewId });
  return savedViewId ? data?.find((v) => v.id === savedViewId) : undefined;
}
